module.exports = __webpack_public_path__ + "static/media/sistema-monitor-plano-elite.d28eab9e.png";